import store from '@/store'
import { lazyLoad } from '../../index'

export default {
  path: 'artists',
  component: lazyLoad('Admin/Data/Artists'),
}
